import { Scene, CascadedShadowGenerator, ShadowGenerator, DirectionalLight, Vector3, Mesh, TransformNode, StandardMaterial, Color3, SpotLight, Texture, MeshBuilder } from '@babylonjs/core';
import { GlobalObject } from './../../utils/GlobalObject';
import { BabylonTools } from '../../utils/BabylonTools';

export class CsmShadow {
    //private csm: CascadedShadowGenerator;
    private light: DirectionalLight;
    private scene: Scene;
    private shadowGenerator: ShadowGenerator | CascadedShadowGenerator;
    private receivers: Mesh[] = [];
    private casters: Mesh[] = [];

    constructor(scene: Scene, light?: DirectionalLight) {
        this.scene = scene;
        if (!light) {
            this.light = new DirectionalLight("sun", new Vector3(-1, -2, -1), this.scene);
            this.light.position = new Vector3(220, 40, 300);
            this.light.intensity = 3.5;
            GlobalObject.getInstance().setSunlight(this.light);
            this.light.autoCalcShadowZBounds = true;

            //var lightSphere = MeshBuilder.CreateSphere("sphere", { diameter: 2 }, this.scene);
            //lightSphere.position = this.light.position;
            //lightSphere.material = new StandardMaterial("light", this.scene);
            //(lightSphere.material as any).emissiveColor = new Color3(1, 1, 0);
        } else {
            this.light = light;
        }
        this.shadowGenerator = new ShadowGenerator(8192, this.light);
        // PCF
        this.shadowGenerator.usePercentageCloserFiltering = true;
        this.shadowGenerator.filteringQuality = 2;  // 0:hight 1:middle 2:low
        this.init();
        //this.test01();
    }
    private init() {
        this.addReceiver(this.scene.getNodeByName("dimian") as TransformNode);
        //this.addReceiver(this.scene.getNodeByName("dimian1") as TransformNode);
        this.addReceiver(this.scene.getNodeByName("dimian2") as TransformNode);

        this.addReceiver(this.scene.getNodeByName("caodi") as TransformNode);
        this.addReceiver(this.scene.getNodeByName("caodi2") as TransformNode);
        this.addReceiver(this.scene.getNodeByName("caodi3") as TransformNode);
    }
    private addReceiver(node: TransformNode) {
        let floors: Mesh[] = [];
        BabylonTools.flatFromGroup(node, floors);
        floors.forEach((floor) => {
            floor.receiveShadows = true;
        })
    }
    public addShadowCaster(node: TransformNode) {
        let casters: Mesh[] = [];
        BabylonTools.flatFromGroup(node, casters);
        casters.forEach((c) => {
            this.shadowGenerator.addShadowCaster(c);
        })
    }
    public getGenerator() {
        return this.shadowGenerator;
    }
    private test01() {
        // Torus
        var torus = MeshBuilder.CreateTorus("torus", { diameter: 4 }, this.scene);
        // Box
        var box = MeshBuilder.CreateBox("box", { size: 3 });
        box.parent = torus;
        this.shadowGenerator.addShadowCaster(torus);
        this.shadowGenerator.useExponentialShadowMap = true;
        // Shadows

        // Animations
        var alpha = 0;
        this.scene.registerBeforeRender(function () {
            torus.rotation.x += 0.01;
            torus.rotation.z += 0.02;

            torus.position = new Vector3(Math.cos(alpha) * 30, 10, Math.sin(alpha) * 30);
            alpha += 0.01;

        });
        /*
        let trees: TransformNode = this.scene.getNodeByName('BP_程序树木_C_20') as TransformNode;
        trees.getChildren().forEach((tree: any) => {
            if (tree._isMesh) {
                this.shadowGenerator.addShadowCaster(tree);
            } else { }
        })
        */

    }
}